export default __webpack_public_path__ + "static/media/SUI.81d4394d.svg";